import InfiniteScrollLayout from './infinit-scroll-layout';

export default InfiniteScrollLayout;
